import * as React from "react";
import { PINResetForm } from "./PINResetForm";
import { OBRSettingsProvider } from "./OBRSettings";

export const PINResetPage: React.FC = (props) => {
  const hash = window.location.hash;
  const keyValuePairs = hash.slice(1).split("&");
  const hashValues = keyValuePairs.reduce((acc, pair) => {
    const [key, value] = pair.split("=");
    acc[key] = value;
    return acc;
  }, {} as Record<string, string>);

  const section = hashValues["section"];
  const borrowerNumber = parseInt(hashValues["borrowerNumber"]);
  const verificationCode = hashValues["verificationCode"];

  // TODO handle configId
  const configId = hashValues["configId"];

  return (
    <React.Fragment>
      {section === "resetPIN" && (
        <OBRSettingsProvider>
          <PINResetForm
            borrowerNumber={borrowerNumber}
            verificationCode={verificationCode}
          ></PINResetForm>
        </OBRSettingsProvider>
      )}
    </React.Fragment>
  );
};
